import { useEffect, useState } from 'react'

import { fetchAttributeOptions } from 'api/AccountActivityAPI'
import { FilterableEntity, FilterConfigAndAvailableValues, FilterValueType } from 'utils/filters'

const formatOptions = (options?: string[]) =>
  options?.map((option: string) => ({ value: option, label: option })) || []

const shouldFetchOptions = (filter: FilterConfigAndAvailableValues) =>
  filter.valueType === FilterValueType.STRING &&
  filter.attributeType === FilterValueType.STRING &&
  filter.filterType === FilterableEntity.CUSTOM_ATTRIBUTE

export default function(filter: FilterConfigAndAvailableValues, searchValue: string): any[] {
  const [options, setOptions] = useState(filter.values)

  useEffect(() => {
    if (shouldFetchOptions(filter)) {
      fetchAttributeOptions(filter.filterDisplayName, searchValue).then(response =>
        setOptions(formatOptions(response.data))
      )
    } else {
      setOptions(filter.values)
    }
  }, [filter, searchValue])

  return options
}
